// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"213e031f","787":"22d03536"}[chunkId] + ".css";
};